var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row event-list"},_vm._l((_vm.eventList),function(item,index){return _c('event-list-item',{key:index,staticClass:"item",class:{center: index % 3 === 1},attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }